import React, { FunctionComponent } from 'react';

import {
  default as MuiTableContainer,
  TableContainerProps,
} from '@mui/material/TableContainer';

const TableContainer: FunctionComponent<
  TableContainerProps<React.ElementType>
> = (props: TableContainerProps<React.ElementType>) => {
  return <MuiTableContainer {...props}>{props.children}</MuiTableContainer>;
};

export default TableContainer;
